import styled from 'styled-components'

export const StyledTabDiv = styled.ul`
  display: flex;
  padding: 0;
  margin: 0 0 2rem 0;
  list-style: none;
`

export const StyledButtonContainer = styled.li`
  list-style: none;
  display: flex;
  flex: 1;
  padding: 0;
  margin: 0 0.5rem 0 0;
  &:last-child {
    margin-right: 0;
  }

  &::before {
    content: none;
  }
`

export const StyledTabButton = styled.button`
  cursor: pointer;
  padding: 1rem;
  font-family: ${(props) => props.theme.fonts.secondaryFont};
  background-color: ${(props) => props.theme.colors.lighterGrey};
  border-top: 4px solid ${(props) => props.theme.colors.lighterGrey};
  flex: 1;
  text-align: center;
  transition:
    background-color, border,
    ${(props) => props.theme.transitions.quickTransition};
  font-size: 1.7rem;
  color: inherit;
  border-radius: 0;
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    border-color: ${(props) => props.theme.colors.body};
    background-color: ${(props) => props.theme.colors.lighterGrey};
  }

  &:focus {
    background-color: ${(props) => props.theme.colors.lighterGrey};
    border-color: ${(props) => props.theme.colors.body};
  }

  &[aria-selected='true'] {
    background-color: ${(props) => props.theme.colors.white};
    border-color: ${(props) => props.theme.colors.body};
  }
`

export const UnreadAmount = styled.div`
  padding: 2px 7px;
  border-radius: 50px;
  background-color: #f46a00;
  color: ${(props) => props.theme.colors.white};
  margin-left: 10px;
  font-family: ${(props) => props.theme.fonts.secondaryFont};
  font-size: 1.7rem;
`

export const UnreadDot = styled.div`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: #f46a00;
  margin-left: 10px;
`

export const TabContainerNew = styled.div`
  display: flex;
  width: 65%;
  justify-content: center;
  margin: 0 auto;
`

export const TabButton = styled.button`
  display: flex;
  align-items: center;
  flex-direction: column;
  background-color: transparent;
  width: 100%;
  position: relative;

  &:hover {
    background-color: transparent;
  }

  &:focus {
    background-color: transparent;
  }

  &[aria-selected='true'] {
    background-color: transparent;
  }
`
export const ButtonInsideContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-bottom: 20px;
`

export const TabSlider = styled.div`
  position: absolute;
  width: 100%;
  height: ${(props) => (props.isActive ? '16px' : '4px')};
  bottom: ${(props) => (props.isActive ? 0 : '6px')};
  border-radius: ${(props) => (props.isActive ? '10px' : 0)};
  border-bottom-left-radius: ${(props) =>
    props.isActive || !props.index ? '10px' : 0};
  border-bottom-right-radius: ${(props) =>
    props.isActive || props.array.length - 1 === props.index ? '10px' : 0};
  border-top-left-radius: ${(props) =>
    props.isActive || !props.index ? '10px' : 0};
  border-top-right-radius: ${(props) =>
    props.isActive || props.array.length - 1 === props.index ? '10px' : 0};
  bottom: ${(props) => (props.isActive ? -14 : -6)};
  bottom: ${(props) => (props.isActive ? -14 : -6)};
  background-color: ${(props) => (props.isActive ? '#2E872A' : '#D0E2CF')};
`

export const ButtonText = styled.p`
  color: ${(props) => (props.isActive ? 'black' : 'gray')};
  margin-bottom: 0;
  font-family: ${(props) => props.theme.fonts.secondaryFont};
  font-size: 1.7rem;
`
